// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"545": "vendors","750": "mercury-tokens",}[chunkId] || chunkId) + "-" + {"545": "e1225bb530dac917","567": "5e5de4efd3bf2be1","750": "d475b2b645787f2a",}[chunkId] + ".css"
}